import { ChannelAddAdmin } from "../../proto/ChannelAddAdmin_pb";
import { ChannelGetMemberListResponse } from "../../proto/ChannelGetMemberList_pb";
import { ChannelKickAdmin } from "../../proto/ChannelKickAdmin_pb";
import { ChatSetActionResponse } from "../../proto/ChatSetAction_pb";
import { ClientGetRoomListResponse } from "../../proto/ClientGetRoomList_pb";
import { ChannelRoom, GroupRoom, RegisteredUser, Room, RoomMessage } from "../../proto/Global_pb";
import { GroupAddAdmin } from "../../proto/GroupAddAdmin_pb";
import { GroupGetMemberListResponse } from "../../proto/GroupGetMemberList_pb";
import { GroupKickAdmin, GroupKickAdminResponse } from "../../proto/GroupKickAdmin_pb";
import { ChannelAvatarAddResponse } from "../../proto/ChannelAvatarAdd_pb";
import { GroupAvatarAddResponse } from "../../proto/GroupAvatarAdd_pb";
import { GroupChangeMemberRights } from "../../proto/GroupChangeMemberRights_pb";

export const CLEAR_ROOMS = "CLEAR_ROOMS";
export const ADD_ROOMS = "ADD_ROOMS";
export const UPDATE_ROOM_STATUS = "UPDATE_ROOM_STATUS";
export const EDIT_ROOM = "EDIT_ROOM";
export const EDIT_ROOM_USERNAME = "EDIT_ROOM_USERNAME";
export const EDIT_ROOM_DESCRIPTION = "EDIT_ROOM_DESCRIPTION";
export const EDIT_ROOM_EXTRA = "EDIT_ROOM_EXTRA";
export const UPDATE_ROOM_PARTICIPANT = "UPDATE_ROOM_PARTICIPANT";
export const REMOVE_ROOM = "REMOVE_ROOM";
export const ADD_ROOM_MEMBERS = "ADD_ROOM_MEMBERS";
export const REMOVE_ROOM_MEMBER = "REMOVE_ROOM_MEMBER";
export const REMOVE_ROOM_MEMBERS = "REMOVE_ROOM_MEMBERS";
export const ADD_ADMIN = "ADD_ADMIN";
export const KICK_ADMIN = "KICK_ADMIN";
export const SET_ROOM_ACTION = "SET_ROOM_ACTION";
export const DELETE_ROOM_ACTION = "DELETE_ROOM_ACTION";
export const SET_CURRENT_ROOM = "SET_CURRENT_ROOM";
export const UPDATE_CLIENT_MUTE_ROOM = "UPDATE_CLIENT_MUTE_ROOM";
export const SET_CURRENT_ROOM_EXTRA = "SET_CURRENT_ROOM_EXTRA";
export const UPDATE_ROOM_LAST_MESSAGE_STATUS = "UPDATE_ROOM_LAST_MESSAGE_STATUS";
export const UPDATE_ROOM_LAST_MESSAGE = "UPDATE_ROOM_LAST_MESSAGE";
export const UPDATE_CHANNEL_ROOM_AVATAR = "UPDATE_CHANNEL_ROOM_AVATAR";
export const UPDATE_GROUP_ROOM_AVATAR = "UPDATE_GROUP_ROOM_AVATAR";
export const UPDATE_ROOM_MEMBER_RIGHTS = "UPDATE_ROOM_MEMBER_RIGHTS";
export const UPDATE_ROOM_COMPLETED = "UPDATE_ROOM_COMPLETED";
export const UPDATE_ROOM_READONLY = "UPDATE_ROOM_READONLY";
export const UPDATE_ROOM_MEMBER_LIST = "UPDATE_ROOM_MEMBER_LIST";

export type RoomsType = {
  [roomId in Room.AsObject["id"]]: Room.AsObject;
};
export type RoomListType = Array<Room.AsObject["id"]>;
export type RoomMembersType = {
  [roomId in Room.AsObject["id"]]: {
    [userId in GroupGetMemberListResponse.Member.AsObject["userid"] | ChannelGetMemberListResponse.Member.AsObject["userid"]]:
      | GroupGetMemberListResponse.Member.AsObject
      | ChannelGetMemberListResponse.Member.AsObject;
  };
};
export type RoomActionType = {
  [roomId in Room.AsObject["id"]]: {
    userId: Array<RegisteredUser.AsObject["id"]>;
    action: ChatSetActionResponse.AsObject["action"];
  };
};
export type UpdateRoomMemberRights = {
  roomId: Room.AsObject["id"];
  roomRights: GroupChangeMemberRights.MemberRights.AsObject;
};
export type CurrentRoomType = Room.AsObject["id"] | undefined;
export type PrevRoomType = Room.AsObject["id"] | undefined;
export type CurrentRoomExtraType = { notJoined: boolean; subscribed: boolean; isPrivate?: boolean; inviteToken?: string };
export type UpdateChannelRoomAvatar = ChannelAvatarAddResponse.AsObject;
export type UpdateGroupRoomAvatar = GroupAvatarAddResponse.AsObject;
export type RoomStateType = {
  rooms: RoomsType;
  roomList: RoomListType;
  roomListStatus: "pending" | "resolved" | "rejected";
  isCompletedRoomList: boolean;
  roomMembers: RoomMembersType;
  roomAction: RoomActionType;
  currentRoom: CurrentRoomType;
  prevRoom: PrevRoomType;
  currentRoomExtra: CurrentRoomExtraType;
};

export type ClearRoomsType = {
  type: typeof CLEAR_ROOMS;
  payload: undefined;
};

export type UpdateRoomMemberRightsType = {
  type: typeof UPDATE_ROOM_MEMBER_RIGHTS;
  payload: UpdateRoomMemberRights;
};

export type UpdateChannelRoomAvatarType = {
  type: typeof UPDATE_CHANNEL_ROOM_AVATAR;
  payload: UpdateChannelRoomAvatar;
};
export type UpdateGroupRoomAvatarType = {
  type: typeof UPDATE_GROUP_ROOM_AVATAR;
  payload: UpdateGroupRoomAvatar;
};

export type AddRoomsActionType = {
  type: typeof ADD_ROOMS;
  payload: ClientGetRoomListResponse.AsObject["roomsList"];
};
export type EditRoomActionType = {
  type: typeof EDIT_ROOM;
  payload: {
    roomId: Room.AsObject["id"];
    room: Partial<Room.AsObject>;
  };
};
export type EditRoomUsernameActionType = {
  type: typeof EDIT_ROOM_USERNAME;
  payload: {
    roomId: Room.AsObject["id"];
    username: string;
  };
};
export type EditRoomDescriptionActionType = {
  type: typeof EDIT_ROOM_DESCRIPTION;
  payload: {
    roomId: Room.AsObject["id"];
    description: string;
  };
};

export type EditRoomExtra = {
  type: typeof EDIT_ROOM_EXTRA;
  payload: {
    roomId: Room.AsObject["id"];
    channelRoomExtra?: Partial<ChannelRoom.AsObject>;
    groupRoomExtra?: Partial<GroupRoom.AsObject>;
  };
};

export type UpdateRoomParticipant = {
  type: typeof UPDATE_ROOM_PARTICIPANT;
  payload: {
    roomId: Room.AsObject["id"];
    action: "inc" | "dec";
    value: number;
  };
};

export type RemoveRoomActionType = {
  type: typeof REMOVE_ROOM;
  payload: Room.AsObject["id"];
};

export type AddRoomMembersActionType = {
  type: typeof ADD_ROOM_MEMBERS;
  payload: {
    roomId: Room.AsObject["id"];
    memberList: GroupGetMemberListResponse.AsObject["memberList"] | ChannelGetMemberListResponse.AsObject["memberList"];
  };
};

export type UpdateRoomMemberList = {
  type: typeof UPDATE_ROOM_MEMBER_LIST;
  payload: {
    roomId: Room.AsObject["id"];
    memberList: GroupGetMemberListResponse.AsObject["memberList"] | ChannelGetMemberListResponse.AsObject["memberList"];
  };
};

export type RemoveRoomMemberActionType = {
  type: typeof REMOVE_ROOM_MEMBER;
  payload: {
    roomId: Room.AsObject["id"];
    memberId: GroupGetMemberListResponse.Member.AsObject["userid"] | ChannelGetMemberListResponse.Member.AsObject["userid"];
  };
};
export type RemoveRoomMembersActionType = {
  type: typeof REMOVE_ROOM_MEMBERS;
  payload: Room.AsObject["id"];
};
export type AddAdminActionType = {
  type: typeof ADD_ADMIN;
  payload: {
    roomId: Room.AsObject["id"];
    memberId: GroupGetMemberListResponse.Member.AsObject["userid"] | ChannelGetMemberListResponse.Member.AsObject["userid"];
    adminrights: GroupAddAdmin.AdminRights.AsObject | ChannelAddAdmin.AdminRights.AsObject;
    permission: GroupAddAdmin.AsObject["permission"];
    isMine: boolean;
  };
};
export type KickAdminActionType = {
  type: typeof KICK_ADMIN;
  payload: {
    roomId: GroupKickAdmin.AsObject["roomId"] | ChannelKickAdmin.AsObject["roomId"];
    memberId: GroupKickAdmin.AsObject["memberId"] | ChannelKickAdmin.AsObject["memberId"];
    memberRights?: GroupKickAdminResponse.AsObject["permission"];
    isMine: boolean;
  };
};
export type SetRoomActionActionType = {
  type: typeof SET_ROOM_ACTION;
  payload: {
    roomId: Room.AsObject["id"];
    userId: Array<RegisteredUser.AsObject["id"]>;
    action: ChatSetActionResponse.AsObject["action"];
  };
};
export type DeleteRoomActionActionType = {
  type: typeof DELETE_ROOM_ACTION;
  payload: {
    roomId: Room.AsObject["id"];
    userId: RegisteredUser.AsObject["id"];
    action: ChatSetActionResponse.AsObject["action"];
  };
};
export type SetCurrentRoomActionType = {
  type: typeof SET_CURRENT_ROOM;
  payload: CurrentRoomType;
};
export type UpdateClientMuteRoomActionType = {
  type: typeof UPDATE_CLIENT_MUTE_ROOM;
  payload: {
    roomId: Room.AsObject["id"];
    roomMute: Room.AsObject["roomMute"];
  };
};
export type SetCurrentRoomExtraType = {
  type: typeof SET_CURRENT_ROOM_EXTRA;
  payload: Partial<CurrentRoomExtraType>;
};
export type UpdateRoomLastMessageStatus = {
  type: typeof UPDATE_ROOM_LAST_MESSAGE_STATUS;
  payload: {
    roomId: Room.AsObject["id"];
    status: RoomMessage.AsObject["status"];
  };
};
export type UpdateRoomLastMessage = {
  type: typeof UPDATE_ROOM_LAST_MESSAGE;
  payload: {
    roomId: Room.AsObject["id"];
    lastMessage: RoomMessage.AsObject["message"];
  };
};

export type UpdateRoomStatus = {
  type: typeof UPDATE_ROOM_STATUS;
  payload: RoomStateType["roomListStatus"];
};

export type UpdateFetchRoomCompletedType = {
  type: typeof UPDATE_ROOM_COMPLETED;
  payload: boolean;
};

export type UpdateRoomReadOnlyType = {
  type: typeof UPDATE_ROOM_READONLY;
  payload: RoomMessage.AsObject["roomId"];
};

export type RoomsActionTypes =
  | ClearRoomsType
  | AddRoomsActionType
  | EditRoomActionType
  | EditRoomUsernameActionType
  | EditRoomDescriptionActionType
  | EditRoomExtra
  | UpdateRoomParticipant
  | RemoveRoomActionType
  | AddRoomMembersActionType
  | RemoveRoomMemberActionType
  | RemoveRoomMembersActionType
  | AddAdminActionType
  | KickAdminActionType
  | SetRoomActionActionType
  | SetCurrentRoomActionType
  | UpdateClientMuteRoomActionType
  | SetCurrentRoomExtraType
  | UpdateRoomLastMessageStatus
  | UpdateRoomLastMessage
  | UpdateChannelRoomAvatarType
  | UpdateGroupRoomAvatarType
  | DeleteRoomActionActionType
  | UpdateRoomMemberRightsType
  | UpdateRoomStatus
  | UpdateFetchRoomCompletedType
  | UpdateRoomReadOnlyType
  | UpdateRoomMemberList;
